import htmlDecode from "../utils/htmlDecode";
import loadContextData from "../utils/loadContextData";
import { initClickHandler } from "../utils/initClickHandler";
import insertNodeAfter from "../utils/insertNodeAfter";
import createTemplate from "../utils/createTemplate";

import { URL_CHANGE_EVENT } from "../consts";

function renderCounter(currentSlide, slides, container) {
    const lengthContainer = container.querySelector(".fullscreen-slideshow--count__length");
    const currentIndexContainer = container.querySelector(".fullscreen-slideshow--count__current");

    lengthContainer.innerText = slides.length;
    currentIndexContainer.innerText = currentSlide.index + 1;
}

function renderMedia(currentSlide, container) {
    const mediaContainer = container.querySelector(".fullscreen-slideshow__media--container");
    mediaContainer.innerHTML = htmlDecode(currentSlide.mediaHtml);
}

function renderHeadline(currentSlide) {
    const { headline, headline_html, linkout_url } = currentSlide;
    if (headline_html) {
        return htmlDecode(headline_html);
    } else if (linkout_url) {
        return htmlDecode(`<a href="${linkout_url}" target="_blank">${headline}</a>`);
    } else {
        return htmlDecode(headline);
    }
}

function buyTemplate({
    shouldComparePrice,
    product_compare_at_price,
    price,
    linkout_url,
    buyNowCaption,
}) {
    return `
    <div class="rebellt-ecommerce--sum">
        <div class="rebellt-ecommerce--price">
            ${
                shouldComparePrice
                    ? `<span class="rebellt-ecommerce--compare-at-price">$${product_compare_at_price}</span>`
                    : ""
            }
            ${price}
        </div>
        <div class="rebellt-ecommerce--buy">
            <a href="${linkout_url}" class="rebellt-ecommerce--btn" target="_blank">${buyNowCaption}</a>
        </div>
    </div>
`;
}

function renderBuy(currentSlide, buyNowCaption = "Buy Now") {
    const { linkout_url, product_price, product_compare_at_price } = currentSlide;
    let html = "";
    if (linkout_url || (product_price && product_price !== "0")) {
        const shouldComparePrice =
            product_compare_at_price &&
            product_compare_at_price !== "0" &&
            product_compare_at_price !== product_price;
        const price = product_price && product_price !== "0" ? `$${product_price}` : "";
        html = buyTemplate({
            shouldComparePrice,
            product_compare_at_price,
            price,
            linkout_url,
            buyNowCaption,
        });
    }
    return htmlDecode(html);
}

function renderDataFields(currentSlide, container, context) {
    const slideHeadline = container.querySelector("._headline");
    const slideBody = container.querySelector("._body");
    const slideCaption = container.querySelector("._caption");
    const slideCredit = container.querySelector("._credit");
    const slideBuy = container.querySelector("._buy");

    const { body, caption, credit } = currentSlide;
    slideHeadline.innerHTML = renderHeadline(currentSlide);
    slideBody.innerHTML = htmlDecode(body);
    slideCaption.innerHTML = htmlDecode(caption);
    slideCredit.innerHTML = htmlDecode(credit);
    slideBuy.innerHTML = renderBuy(currentSlide, context.settings.buyNowCaption);
}

function renderSlide(currentSlide, context, container, eventBus) {
    renderCounter(currentSlide, context.slides, container);
    renderMedia(currentSlide, container);
    renderDataFields(currentSlide, container, context);

    eventBus.publish(URL_CHANGE_EVENT, {
        url: currentSlide.href,
        id: currentSlide.postId,
        headline: currentSlide.headline,
        trackPageView: true, // @NOTE: add context and use from engine setting
    });
}

function createSlideshowFromTemplate() {
    const container = containerTemplate.getElement();
    container.classList.add("fullscreen-container");
    return container;
}

function initNavigationButtons(slideView, context, activeSlide, eventBus) {
    const slidesContext = context.slides;
    const nextButton = slideView.querySelector(".fullscreen-slideshow--next");
    const prevButton = slideView.querySelector(".fullscreen-slideshow--prev");

    initClickHandler(nextButton, () => {
        const slide = slidesContext[activeSlide.index + 1] || slidesContext[0];
        renderSlide(slide, context, slideView, eventBus);
        activeSlide = slide;
    });

    initClickHandler(prevButton, () => {
        const slide =
            slidesContext[activeSlide.index - 1] || slidesContext[slidesContext.length - 1];
        renderSlide(slide, context, slideView, eventBus);
        activeSlide = slide;
    });
}

function initCloseButton(container, slideView) {
    const closeButton = slideView.querySelector(".fullscreen-slideshow--close");
    initClickHandler(closeButton, () => {
        container.parentElement.removeChild(slideView);
    });
}

function currentUri() {
    return `${location.protocol}//${location.hostname}${location.pathname}`;
}

function renderSlideshow(container, context, eventBus, matchingSlide) {
    let activeSlide = matchingSlide || context.slides[0];

    const slideView = createSlideshowFromTemplate(container);
    insertNodeAfter(container, slideView);

    renderSlide(activeSlide, context, slideView, eventBus);

    initNavigationButtons(slideView, context, activeSlide, eventBus);
    initCloseButton(container, slideView);
}

function getSlidesContext(slidesWrapper) {
    return loadContextData(`#${slidesWrapper.dataset.contextId}`, slidesWrapper);
}

export default function assemblerFullScreenSlideshow(appContext, slidesWrapper) {
    const eventBus = appContext.eventBus;
    const context = {
        slides: getSlidesContext(slidesWrapper),
        settings: {
            buyNowCaption: slidesWrapper.dataset.buyNowCaption,
        },
    };
    const matchingSlide = context.slides.find((slide) => slide.href === currentUri());

    if (matchingSlide) {
        window.scrollTo(0, slidesWrapper.offsetTop);
        renderSlideshow(slidesWrapper, context, eventBus, matchingSlide);
    }

    initClickHandler(slidesWrapper, (event) => {
        const slideElement = event.target.closest("[data-slide]");
        const slideIndex = slideElement ? parseInt(slideElement.dataset.slide - 1, 10) : 0;
        renderSlideshow(slidesWrapper, context, eventBus, context.slides[slideIndex]);
    });
}

const containerTemplate = createTemplate(`
<div class="fullscreen-slideshow">
    <div class="fullscreen-slideshow__container">
        <div class="fullscreen-slideshow__sidebar">
            <div class="fullscreen-slideshow__sidebar--controls">
                <a href="javascript:;" class="fullscreen-slideshow--prev"><i class="fa fa-angle-left"></i></a>
                <a href="javascript:;" class="fullscreen-slideshow--next"><i class="fa fa-angle-right"></i></a>

                <div class="fullscreen-slideshow--count">
                    <strong class="fullscreen-slideshow--count__current"></strong>
                    /
                    <small class="fullscreen-slideshow--count__length"></small>
                </div>

                <a href="javascript:;" class="fullscreen-slideshow--close">×</a>
            </div>
            <div class="fullscreen-slideshow__sidebar--content">
                <h3 class="_headline"></h3>
                <div class="_body"></div>
                <div class="_caption"></div>
                <div class="_credit"></div>
                <div class="_buy"></div>
                <div class="_shares">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=" target="_blank" data-track-share="Facebook" class="fb-link share-popup fullscreen-slideshow__sidebar--content__a">
                        <i class="sprite-shares-facebook fullscreen-slideshow__sidebar--content__i fa fa-facebook"></i>
                    </a>
                    <a href="https://twitter.com/intent/tweet?url=" target="_blank" data-track-share="Twitter" class="tw-link share-popup fullscreen-slideshow__sidebar--content__a">
                        <i class="sprite-shares-twitter fullscreen-slideshow__sidebar--content__i fa fa-twitter"></i>
                    </a>
                    <a href="https://pinterest.com/pin/create/button/?url=" target="_blank" data-track-share="Pinterest" class="pin-link share-popup fullscreen-slideshow__sidebar--content__a">
                        <i class="sprite-shares-pinterest fullscreen-slideshow__sidebar--content__i fa fa-pinterest"></i>
                    </a>
                </div>
            </div>
            <div class="fullscreen-slideshow__sidebar--ads"></div>
        </div>
        <div class="fullscreen-slideshow__media">
            <div class="fullscreen-slideshow__top-ads"></div>
            <div class="fullscreen-slideshow__media--container">
                <a href="javascript:;" class="fullscreen-slideshow__media--fullsize--open"><i class="open-icon"></i></a-->
            </div>
        </div>
    </div>
    <div class="fullscreen-slideshow__media--fullsize hidden">
        <a href="javascript:;" class="fullscreen-slideshow__media--fullsize--close"><i class="close-icon hairline"></i></a>
        <img src="#" class="fullscreen-slideshow__media--fullsize__img" />
    </div>
    <div class="fullscreen-slideshow__fullscreen-ad hidden"></div>
</div>
`);
